import React from 'react'
import bg from '../../images/background/5.jpg'

const VenueSection = (props) => {

    return (
        <section className="location-one"  style={{backgroundImage: `url(${bg})`}}>
            <div className="auto-container">
                <div className="sec-title title-anim centered">
                    <div className="sec-title_title">Venue</div>
                    <h2 className="sec-title_heading">Direction For The Retreat</h2>
                </div>
                <div className="row clearfix">
                    <div className="location-one_map-column col-lg-8 col-md-12 col-sm-12">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14414.381763303149!2d91.78769780395066!3d25.418349239608336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3750885383ffd041%3A0xe79e6fc5020f7596!2sMawkdok%2C%20Meghalaya%20793108!5e0!3m2!1sen!2sin!4v1759135849298!5m2!1sen!2sin" allowFullScreen=""></iframe>
                    </div>
                    <div className="location-one_info-column col-lg-4 col-md-12 col-sm-12">
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-map"></div>
                                    <strong>ADDRESS</strong>
                                    Mawkdok Village, Meghalaya
                                </div>
                            </div>
                        </div>
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-clock"></div>
                                    <strong>timing</strong>
                                    October 18 - 20, 2025
                                </div>
                            </div>
                        </div>
                        <div className="location-info_block">
                            <div className="location-info_block-inner">
                                <div className="location-info_block-content">
                                    <div className="location-info_block-icon flaticon-email-1"></div>
                                    <strong>MAIL TO US</strong>
                                    hello@thelushminds.in
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default VenueSection;